//React
import React from 'react';

//Pages
import { SitesManagement } from 'pages/sites';
import { useAdminSiteManagementData } from './useAdminSiteManagementData';

export const AdminSiteManagement: React.FC = () => {
  const {
    sites,
    payors,
    organizations,
    isLoading,
    isError,
    isFetching,
    errorMessage,
  } = useAdminSiteManagementData();

  return (
    <SitesManagement
      sites={sites}
      payors={payors}
      organizations={organizations}
      isLoading={isLoading}
      isError={isError}
      isFetching={isFetching}
      errorMessage={errorMessage}
    />
  );
};
